import { render, staticRenderFns } from "./AamsRegSealUsageApproval.vue?vue&type=template&id=0a02de68&scoped=true&"
import script from "./AamsRegSealUsageApproval.vue?vue&type=script&lang=js&"
export * from "./AamsRegSealUsageApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a02de68",
  null
  
)

export default component.exports